// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Curry = require("@rescript/std/lib/js/curry.js");
var React = require("react");
var Context = require("../../../provider/Context.bs.js");
var Atom_Box = require("../../atom/Atom_Box.bs.js");
var Atom_Cta = require("../../atom/Atom_Cta.bs.js");
var UseOnBlur = require("../../../hook/UseOnBlur.bs.js");
var UseToggle = require("../../../hook/UseToggle.bs.js");
var Atom_Column = require("../../atom/Atom_Column.bs.js");
var Type_Header = require("../../../type/Type_Header.bs.js");
var Atom_Divider = require("../../atom/Atom_Divider.bs.js");
var User_Context = require("../../../user/User_Context.bs.js");
var User_Provider = require("../../../user/User_Provider.bs.js");
var UseClickOutside = require("../../../hook/UseClickOutside.bs.js");
var Particle_Screen_Ds = require("../../particle/Particle_Screen_Ds.bs.js");
var UseTrackingAmplitude = require("../../../hook/UseTrackingAmplitude.bs.js");
var Particle_Background_Ds = require("../../particle/Particle_Background_Ds.bs.js");

var rules = Particle_Screen_Ds.make(undefined, undefined, [CssJs.top({
            NAME: "px",
            VAL: Type_Header.Constants.height.m
          })], undefined, undefined, [
      CssJs.position("absolute"),
      CssJs.top({
            NAME: "px",
            VAL: Type_Header.Constants.height.default
          }),
      CssJs.right({
            NAME: "px",
            VAL: 0
          }),
      CssJs.unsafe("min-width", "max-content")
    ]);

function Organism_Header_Panel$Item_Tooltip(Props) {
  var status = Props.status;
  var userStatus = Props.userStatus;
  var userLabel = Props.userLabel;
  var settings = Props.settings;
  var trackAmplitude = UseTrackingAmplitude.useUserAction("login_button");
  var match = Context.I18n.getState(undefined);
  var match$1 = Context.Config.getState(undefined);
  var match$2 = Context.I18n.getState(undefined);
  var internalAuthEnabled = Context.Config.getFeatureFlippingStatus(/* InternalAuth */9);
  var onLogoutCallback = match$1.api.onLogoutCallback;
  var token = Curry._1(User_Provider.Hook.useToken, undefined);
  var onClickLogin = function (param) {
    Curry._1(trackAmplitude, undefined);
  };
  var href = internalAuthEnabled ? match.myArteUrl : (
      userStatus !== 1 ? match.loginUrl : match.profileUrl
    );
  if (status) {
    return null;
  } else {
    return React.createElement(Atom_Column.make, {
                background: Particle_Background_Ds.userPanel,
                children: null,
                rules: rules
              }, React.createElement(Atom_Cta.Link.make, {
                    href: settings.href,
                    label: settings.title,
                    style: {
                      TAG: /* Header */10,
                      _0: {
                        TAG: /* HeaderPanel */13,
                        _0: /* Setting */0
                      }
                    }
                  }), React.createElement(Atom_Cta.Link.make, {
                    href: href,
                    label: userLabel,
                    onClick: onClickLogin,
                    style: {
                      TAG: /* Header */10,
                      _0: {
                        TAG: /* HeaderPanel */13,
                        _0: /* Login */1
                      }
                    }
                  }), userStatus !== 1 ? null : React.createElement(React.Fragment, undefined, React.createElement(Atom_Divider.make, {
                          style: Atom_Divider.userPanel
                        }), React.createElement(Atom_Cta.Button.make, {
                          label: match$2.labels.mona.navigation.disconnect,
                          onClick: (function (param) {
                              User_Provider.disconnect(User_Context.getEnv(undefined), token, onLogoutCallback);
                            }),
                          style: {
                            TAG: /* Header */10,
                            _0: {
                              TAG: /* HeaderPanel */13,
                              _0: /* Logout */2
                            }
                          }
                        })));
  }
}

var Item_Tooltip = {
  rules: rules,
  make: Organism_Header_Panel$Item_Tooltip
};

function Organism_Header_Panel(Props) {
  var forcedUserStatus = Props.forcedUserStatus;
  var userLabels = Props.userLabels;
  var searchState = Props.searchState;
  var settings = Props.settings;
  var ref = React.useRef(null);
  var userStatus = Curry._1(User_Provider.Hook.useUserStatus, undefined);
  var userStatus$1 = forcedUserStatus !== undefined ? forcedUserStatus : userStatus;
  var displayMobileRules = searchState ? Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "flex") : Particle_Screen_Ds.make(undefined, undefined, undefined, "flex", undefined, "none");
  var match = UseToggle.make(undefined, undefined, undefined, undefined);
  var close = match.close;
  var state = match.state;
  UseOnBlur.make(ref, close);
  UseClickOutside.make(ref, close);
  var label = userStatus$1 !== 1 ? userLabels.login : userLabels.pseudo;
  return React.createElement(Atom_Box.make, {
              children: null,
              ref_: ref
            }, React.createElement(Atom_Cta.Button.make, {
                  id: "login-button",
                  onClick: match.toggle,
                  screenReadersLabel: label,
                  style: {
                    TAG: /* Header */10,
                    _0: {
                      TAG: /* UserPanel */12,
                      _0: displayMobileRules,
                      _1: state
                    }
                  }
                }), React.createElement(Organism_Header_Panel$Item_Tooltip, {
                  status: state,
                  userStatus: userStatus$1,
                  userLabel: label,
                  settings: settings
                }));
}

var make = Organism_Header_Panel;

exports.Item_Tooltip = Item_Tooltip;
exports.make = make;
/* rules Not a pure module */
